import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, ButtonGroup, Divider, useDisclosure } from '@chakra-ui/react';
import React, { Children, cloneElement, PropsWithChildren, ReactElement, useCallback } from 'react';

export interface DialogProps {
  cancelButtonText?: string;
  confirmButtonText?: string;
  dialogHeader: string;
  dialogBody: string;
}

type WrapperDialogProps = PropsWithChildren & DialogProps;

export default function WrapperDialog({ 
  children, 
  dialogHeader, 
  dialogBody, 
  cancelButtonText = 'Cancelar', 
  confirmButtonText = 'Confirmar' 
}: WrapperDialogProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const childrenRef = React.useRef();

  const child = Children.only(children);
  const clonedElement = cloneElement(
    child as ReactElement,
    { 
      pointerEvents: 'none',
      ref: childrenRef
    }
  );

  const handleChildClick = useCallback((e: React.MouseEvent) => {
    onOpen();
    e.stopPropagation();
  }, [onOpen]);

  const handleConfirmClick = useCallback(() => {
    onClose();
    childrenRef.current?.click()
  }, [onClose]);


  return (
    <>
      <Box 
        cursor="pointer"
        onClick={handleChildClick}
      >
        {clonedElement}
      </Box>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {dialogHeader}
            </AlertDialogHeader>

            <AlertDialogBody mt="10px">
              {dialogBody}
            </AlertDialogBody>

            <Divider />

            <AlertDialogFooter>
              <ButtonGroup>
                <Button 
                  ref={cancelRef} 
                  size="sm" 
                  onClick={onClose}
                >
                  {cancelButtonText}
                </Button>
                <Button 
                  variant="primary" 
                  size="sm" 
                  onClick={handleConfirmClick}>  
                  {confirmButtonText}
                </Button>
              </ButtonGroup>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
